"use client";

import { useEffect, useRef } from "react";

function getBrowserAgentOptions() {
  const licenseKey = process.env.NEXT_PUBLIC_NEW_RELIC_LICENSE_KEY ?? "";
  const applicationID = process.env.NEXT_PUBLIC_NEW_RELIC_APPLICATION_ID ?? "";
  const accountID = process.env.NEXT_PUBLIC_NEW_RELIC_ACCOUNT_ID;
  const agentID = process.env.NEXT_PUBLIC_NEW_RELIC_AGENT_ID ?? "";
  const trustKey = process.env.NEXT_PUBLIC_NEW_RELIC_TRUST_KEY ?? "";
  const beacon = process.env.NEXT_PUBLIC_NEW_RELIC_BEACON ?? "";
  const errorBeacon = process.env.NEXT_PUBLIC_NEW_RELIC_ERROR_BEACON ?? "";
  const denyBeacon = beacon;

  return {
    info: {
      applicationID,
      beacon,
      errorBeacon,
      licenseKey,
      sa: 1,
    },
    init: {
      ajax: { deny_list: [denyBeacon] },
      browser_consent_mode: { enabled: false },
      distributed_tracing: { enabled: true },
      performance: {
        capture_detail: false,
        capture_marks: false,
        capture_measures: true,
      },
      privacy: { cookies_enabled: true },
    },
    loader_config: {
      accountID,
      agentID,
      applicationID,
      licenseKey,
      trustKey,
    },
  };
}

export default function NewRelicProvider() {
  const browserAgentRef = useRef<unknown>(null);

  useEffect(() => {
    (async () => {
      if (!browserAgentRef.current) {
        const { BrowserAgent } = await import("@newrelic/browser-agent/loaders/browser-agent");
        browserAgentRef.current = new BrowserAgent(getBrowserAgentOptions());
      }
    })();
  }, []);

  return null;
}